import { render, staticRenderFns } from "./CommentListHeader.vue?vue&type=template&id=7ca358ca&"
import script from "./CommentListHeader.vue?vue&type=script&lang=js&"
export * from "./CommentListHeader.vue?vue&type=script&lang=js&"
import style0 from "./CommentListHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports